export default __webpack_public_path__ + "static/media/faq_bg.95439ab3.svg";